import styled from "styled-components";
import { Box } from "@mui/material";

export const InvitationColorPickerContainer = styled(Box)`
	display: flex;
	justify-content: center;
	.outlined {
		outline: 2px solid #799dbc;
		outline-offset: 5px;
	}

	.color-box {
		width: 30px;
		height: 30px;
		cursor: pointer;
	}
`;
